import { skipToken, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import urls from "../urls";
import type { Site } from "../utils/backend-types";

export function useSites({
  projectId,
  variantId
}: {
  projectId?: string;
  variantId?: number;
}) {
  return useQuery({
    queryKey: ["sites-list", { projectId, variantId }],
    queryFn:
      projectId || variantId
        ? () => fetchSites(projectId, variantId)
        : skipToken
  });
}

async function fetchSites(projectId?: string, variantId?: number) {
  const response = await apiWithoutCamelization.get<Array<Site>>(
    urls.apiWithoutCamelization.sites({ projectId, variantId })
  );
  return response.data;
}
